import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import toastr from "toastr";
import {KTMScreen} from "ktm-ui";
import { Search as SearchIcon } from "lucide-react";
import ViewEmployee from './ViewEmployee';
import ViewPolicy from "./ViewPolicy";
import ViewUser from "./ViewUser";
import {PolicyTable, EmployeeTable, ClaimTable, UserTable, DependentTable, EmployeeNotPaginatedTable} from "./SearchTables";
import {Spinner} from "react-bootstrap";

export default KTMScreen(
    {name: "search"},
    class extends React.Component<any, any> {
        state = {
            searchType: "policy",
            searchInput: "",
            firstName: "",
            lastName: "",
            email: "",
            employeephone: "",
            postalCode:"",
            phone:"",
            searchResult: null,
            loading: false,
            claimCard: null,
            employeeData: null,
            employeeId: "",
            policyId: "",
            showViewEmployee: false,
            policyData: null,
            showViewPolicy: false,
            showViewUser: false,
            userData: null,
            page: 1,
            pageSize: 100,
            visiblePageSize: 10,
            totalRecords: 0,      
            pageIndex: 0,
 
        };
        
        handlePageChange = (direction) => {
            this.setState(prevState => {
                const newPage = direction === 'next' ? prevState.page + 1 : Math.max(prevState.page - 1, 1);
                return { page: newPage };
            }, () => {
                this.submitSearch();
            });
        };
        
        handleViewEmployeeClick = (data) => {
            this.setState({
                employeeData: data,
                showViewEmployee: true,
            });
        };

        handleViewPolicyClick = (data) => {
            this.setState({
                policyData: data,
                showViewPolicy: true,
            });
        };

        handleViewUserClick = (data) => {
            this.setState({
                userData: data,
                showViewUser: true,
            });
        };

        handleViewOptimizedEmployeeClick = (data) => {
            this.setState({
                employeeData: data,
                showViewEmployee: true,
            });
        };

        searchBy = (type) => {
            this.setState({searchType: type});
        };

        setInput = (e) => {
            this.setState({
                searchInput: e.target.value,
                page: 1,
                pageIndex: 0,
                searchResult: [],
                totalRecords: 0,
                showViewEmployee: false,
                showViewPolicy: false,
                showViewUser: false,
            });
        };

        setSearchType = (e) => {
            this.setState({
                searchType: e.target.value,
                searchInput: "",
                searchResult: null,
                claimCard: null,
                showViewEmployee: false,
                showViewPolicy: false,
                showViewUser: false,
            });
        };

        setFirstNameInput = (e) => {
            this.setState({
                firstName: e.target.value,
                showViewEmployee: false,
                showViewPolicy: false,
                showViewUser: false,
            });
        };

        setLastNameInput = (e) => {
            this.setState({
                lastName: e.target.value,
                showViewEmployee: false,
                showViewPolicy: false,
                showViewUser: false,
            });
        };

        setEmailInput = (e) => {
            this.setState({
                email: e.target.value,
                showViewEmployee: false,
                showViewPolicy: false,
                showViewUser: false,
            });
        };

        setEmployeePhoneInput = (e) => {
            this.setState({
                employeephone: e.target.value,
                showViewEmployee: false,
                showViewPolicy: false,
                showViewUser: false,
            });
        };

        setPostalCodeInput = (e) => {
            this.setState({
                postalCode: e.target.value,
                showViewEmployee: false,
                showViewPolicy: false,
                showViewUser: false,
            });
        };

        setPhoneInput = (e) => {
            this.setState({
                phone: e.target.value,
                showViewEmployee: false,
                showViewPolicy: false,
                showViewUser: false,
            });
        };

        submitSearch = () => {
            if (this.state.searchInput != null && this.state.searchInput != "") {
               if (this.state.page === 1) {
                    this.setState({
                        loading: true,
                        searchResult: [], 
                        totalRecords: 0,
                        pageIndex: 0,
                    });
                } else {
                this.setState({ loading: true });
                }
                const encodedParamValue = encodeURIComponent(this.state.searchInput);

                fetch(
                    "/api/support/searchsupport?type=" +
                    this.state.searchType +
                    "&input=" +
                    encodedParamValue +
                    "&page=" +
                    this.state.page +
                    "&pageSize=" +
                    this.state.pageSize,
                    {
                        method: "GET",
                    }
                )
                .then((response) => response.json())
                .then((data) => {
                    const newResults = data.results || [];

                    // Filter out duplicates before appending
                    const combined = [
                        ...this.state.searchResult,
                        ...newResults.filter(
                            (r) => !this.state.searchResult.some((existing) => existing.id === r.id)
                        ),
                    ];

                    this.setState({
                        searchResult: combined,
                        totalRecords: data.total,
                        loading: false,
                        claimCard: null,
                    }, () => {
                        if (combined.length === 0) {
                            toastr.error("No search result found", "Error");
                        }
                    });
                })
                .catch((error) => {
                    this.setState({searchResult: null, success: false});
                    toastr.error("Search failed", "Error");
                });
            }
        };
        
        submitOptimizedSearch = () => {
            const { searchType, firstName, lastName, email, employeephone, searchInput } = this.state;
        
            if (firstName || lastName || email || employeephone || searchInput) {
                this.setState({ loading: true });
        
                const params = new URLSearchParams();
                params.append("type", searchType);
                if (firstName) params.append("firstName", firstName.trim());
                if (lastName) params.append("lastName", lastName.trim());
                if (email) params.append("email", email.trim());
                if (employeephone) params.append("employeephone", employeephone.trim());
                if (searchInput) params.append("input", searchInput.trim());
        
                fetch(`/api/support/optimizedsearch?${params.toString()}`, {
                    method: "GET",
                })
                    .then((response) => response.json())
                    .then((data) => {
                        this.setState({
                            searchResult: data.results,
                            totalRecords: data.total,
                            loading: false,
                            claimCard: null,
                        });
                    })
                    .catch((error) => {
                        this.setState({ searchResult: null, success: false, loading: false });
                        toastr.error("Search failed", "Error");
                    });
            } else {
                toastr.error("Please enter at least one search field", "Error");
            }
        };

        submitOptimizedPolicySearch = () => {
            const { searchType, postalCode, phone, searchInput } = this.state;
        
            if (postalCode || phone || searchInput) {
                this.setState({ loading: true });
        
                const params = new URLSearchParams();
                params.append("type", searchType);
                if (postalCode) params.append("postalCode", postalCode.trim());
                if (phone) params.append("phone", phone.trim());
                if (searchInput) params.append("input", searchInput.trim());
    
                fetch(`/api/support/optimizedpolicysearch?${params.toString()}`, {
                    method: "GET",
                })
                    .then((response) => response.json())
                    .then((data) => {
                        this.setState(
                            {
                                searchResult: data.results,
                                totalRecords: data.total,
                                loading: false,
                                claimCard: null,
                            },
                            () => {
                                if (this.state.searchResult.length === 0) {
                                    toastr.error("No search result found", "Error");
                                }
                            }
                        );
                    })
                    .catch((error) => {
                        this.setState({ searchResult: null, success: false, loading: false });
                        toastr.error("Search failed", "Error");
                    });
            } else {
                toastr.error("Please enter at least one search field", "Error");
            }
        };

        renderPaginationControls() {
            const { page, pageSize, totalRecords } = this.state;
            const totalPages = Math.ceil(totalRecords / pageSize);
            return (
                <div className="d-flex justify-content-between align-items-center mt-3">
                <button className="btn btn-secondary" onClick={() => this.handlePageChange('prev')} disabled={page <= 1}>
                    Previous
                </button>
                <span>Page {page} of {totalPages}</span>
                <button className="btn btn-secondary" onClick={() => this.handlePageChange('next')} disabled={page >= totalPages}>
                    Next
                </button>
                </div>
            );
        }

        handleKeyDown = (event) => {
            if (event.key === "Enter") {
                this.submitSearch();
            }
        };

        render() {
            let placeholderText = "Enter search input";
            if (this.state.searchType == "policy") {
                placeholderText = "Enter Policy Holder name, DBA, or policy number..";
            } else if (this.state.searchType == "employee") {
                placeholderText = "Enter employee name, email, or phone number..";
            } else if (this.state.searchType == "claim") {
                placeholderText = "Enter claim number..";
            } else if (this.state.searchType == "dependent") {
                placeholderText = "Enter dependent name..";
            } else if (this.state.searchType == "user") {
                placeholderText = "Enter username, email..";
            }

            let searchInput = (
                <>
                    <div className="search-header">
                        <SearchIcon size={22} />
                        <span>Search</span>
                    </div>
                    <div className="search-input-group">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <select
                                    className="form-select"
                                    onChange={(e) => this.setSearchType(e)}
                                    defaultValue={this.state.searchType}
                                >
                                    <option value="policy">Policy Holder</option>
                                    <option value="employee">Employee</option>
                                    <option value="claim">Claim</option>
                                    <option value="dependent">Dependent</option>
                                    <option value="user">User</option>
                                    <option value="optimizedemployee">Employee's Name, Email or Phone</option>
                                    <option value="optimizedpolicy">Policy Holders's Postal Code or Phone</option>
                                </select>
                            </div>
                            <input
                                onKeyDown={this.handleKeyDown}
                                type="text"
                                className="form-control"
                                name="searchInput"
                                onChange={(e) => this.setInput(e)}
                                value={this.state.searchInput}
                                placeholder={placeholderText}
                            />
                            <button
                                onClick={() => this.submitSearch()}
                                className="btn btn-primary"
                                type="button"
                                disabled={this.state.loading}
                            >
                                Search
                            </button>
                        </div>
                    </div>
                </>
            );

            let optimizedSearchInput = (
                <>
                    <div className="search-header">
                        <SearchIcon size={22} />
                        <span>Search</span>
                    </div>
                    <div className="search-input-group">
                        <div className="mb-3">
                            <select
                                className="form-select mb-3"
                                onChange={(e) => this.setSearchType(e)}
                                defaultValue={this.state.searchType}
                            >
                                <option value="policy">Policy Holder</option>
                                <option value="employee">Employee</option>
                                <option value="claim">Claim</option>
                                <option value="dependent">Dependent</option>
                                <option value="user">User</option>
                                <option value="optimizedemployee">Employee's Name, Email or Phone</option>
                                <option value="optimizedpolicy">Policy Holders's Postal Code or Phone</option>
                            </select>

                            <div className="d-flex gap-2 mb-4">
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    name="firstName"
                                    placeholder="First Name"
                                    onChange={(e) => this.setFirstNameInput(e)}
                                    value={this.state.firstName}
                                />
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    name="lastName"
                                    placeholder="Last Name"
                                    onChange={(e) => this.setLastNameInput(e)}
                                    value={this.state.lastName}
                                />
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    name="email"
                                    placeholder="Email"
                                    onChange={(e) => this.setEmailInput(e)}
                                    value={this.state.email}
                                />
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    name="employeephone"
                                    placeholder="Phone Number"
                                    onChange={(e) => this.setEmployeePhoneInput(e)}
                                    value={this.state.employeephone}
                                />
                            </div>
                            <button
                                onClick={() => this.submitOptimizedSearch()}
                                className="btn btn-primary w-100"
                                type="button"
                                disabled={this.state.loading}
                            >
                                Search
                            </button>
                        </div>
                    </div>
                </>
            );

            let optimizedPolicySearchInput = (
                <>
                    <div className="search-header">
                        <SearchIcon size={22} />
                        <span>Search</span>
                    </div>
                    <div className="search-input-group">
                        <div className="mb-3">
                            <select
                                className="form-select mb-3"
                                onChange={(e) => this.setSearchType(e)}
                                defaultValue={this.state.searchType}
                            >
                                <option value="policy">Policy Holder</option>
                                <option value="employee">Employee</option>
                                <option value="claim">Claim</option>
                                <option value="dependent">Dependent</option>
                                <option value="user">User</option>
                                <option value="optimizedemployee">Employee's Name, Email or Phone</option>
                                <option value="optimizedpolicy">Policy Holders's Postal Code or Phone</option>
                            </select>

                            <div className="d-flex gap-2 mb-2">
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    name="postalCode"
                                    placeholder="Postal Code"
                                    onChange={(e) => this.setPostalCodeInput(e)}
                                    value={this.state.postalCode}
                                />

                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    name="phone"
                                    placeholder="Phone number"
                                    onChange={(e) => this.setPhoneInput(e)}
                                    value={this.state.phone}
                                />
                            </div>
                            <button
                                onClick={() => this.submitOptimizedPolicySearch()}
                                className="btn btn-primary w-100"
                                type="button"
                                disabled={this.state.loading}
                            >
                                Search
                            </button>
                        </div>
                    </div>
                </>
            );
            
            let searchContent = null;
            if (this.state.searchType === "policy") {
                searchContent = (
                    <div>
                        {searchInput}
                        {this.state.loading ? <Spinner className="pad-spinner" animation="border" variant="primary"/> : <></>}
                        {this.state.searchResult && <PolicyTable searchResult={this.state.searchResult} onPolicySelect={this.handleViewPolicyClick}/>}
                        {this.state.showViewPolicy && <ViewPolicy data={this.state.policyData} />}
                    </div>
                );
            } else if (this.state.searchType === "employee") {                
                searchContent = (
                    <div>
                        {searchInput}
                        {this.state.loading ? <Spinner className="pad-spinner" animation="border" variant="primary"/> : <></>}
                        {this.state.searchResult && <EmployeeTable
                                        searchResult={this.state.searchResult.slice(
                                            this.state.pageIndex * this.state.visiblePageSize,
                                            (this.state.pageIndex + 1) * this.state.visiblePageSize
                                        )}
                                        onEmployeeSelect={this.handleViewEmployeeClick}
                                        pageIndex={this.state.pageIndex}
                                        pageSize={this.state.visiblePageSize}
                                        totalRecords={this.state.totalRecords} 
                                        onPageChange={(pageIndex, pageSize) =>
                                            this.setState({ pageIndex }, () => {
                                            // fetch next 100 if needed
                                            const maxVisibleIndex = (pageIndex + 1) * this.state.visiblePageSize;
                                            if (maxVisibleIndex > this.state.searchResult.length && this.state.searchResult.length < this.state.totalRecords) {
                                                    this.setState({ page: this.state.page + 1 }, this.submitSearch);
                                                }
                                            })
                                        }
                        />}
                        {this.state.showViewEmployee && <ViewEmployee data={this.state.employeeData} />}
                    </div>
                );
            } else if (this.state.searchType === "claim") {
                searchContent = (
                    <div>
                        {searchInput}
                        {this.state.loading ? <Spinner className="pad-spinner" animation="border" variant="primary"/> : <></>}
                        {this.state.searchResult && <ClaimTable searchResult={this.state.searchResult} onEmployeeSelect={this.handleViewEmployeeClick}/>}
                        {this.state.showViewEmployee && <ViewEmployee data={this.state.employeeData} />}
                    </div>
                );
            } else if (this.state.searchType === "dependent") {
                searchContent = (
                    <div>
                        {searchInput}
                        {this.state.loading ? <Spinner className="pad-spinner" animation="border" variant="primary"/> : <></>}
                        {this.state.searchResult && <DependentTable searchResult={this.state.searchResult} onEmployeeSelect={this.handleViewEmployeeClick}/>}
                        {this.state.showViewEmployee && <ViewEmployee data={this.state.employeeData} />}
                    </div>
                );
            } else if (this.state.searchType === "user") {
                searchContent = (
                    <div>
                        {searchInput}
                        {this.state.loading ? <Spinner className="pad-spinner" animation="border" variant="primary"/> : <></>}
                        {this.state.searchResult && <UserTable searchResult={this.state.searchResult} onUserSelect={this.handleViewUserClick}/>}
                        {this.state.showViewUser && <ViewUser data={this.state.userData} />}
                    </div>
                );
            } else if (this.state.searchType === "optimizedemployee") {
                searchContent = (
                    <div>
                        {optimizedSearchInput}
                        {this.state.loading ? <Spinner className="pad-spinner" animation="border" variant="primary"/> : <></>}
                        {this.state.searchResult && <EmployeeNotPaginatedTable
                                        searchResult={this.state.searchResult}
                                        onEmployeeSelect={this.handleViewEmployeeClick}
                        />}
                        {this.state.showViewEmployee && <ViewEmployee data={this.state.employeeData} />}
                    </div>
                );
            } else if (this.state.searchType === "optimizedpolicy") {
                searchContent = (
                    <div>
                        {optimizedPolicySearchInput}
                        {this.state.loading ? <Spinner className="pad-spinner" animation="border" variant="primary"/> : <></>}
                        {this.state.searchResult && <PolicyTable searchResult={this.state.searchResult} onPolicySelect={this.handleViewPolicyClick}/>}
                        {this.state.showViewPolicy && <ViewPolicy data={this.state.policyData} />}
                    </div>
                );
            } 

            let searchContainer = (
                <div className="search-card-container">
                    <div className="search-card">{searchContent}</div>
                </div>
            );

            return <div>{searchContainer}</div>;
        }
    }
);
